import { useEffect, useState } from "react"
import { HomeI } from "../models/home"
import { getHome } from "../services/home"
import { getHomeCategorias } from "../services/home"

const useFetchHome = () => {

    const [home, setHome] = useState<HomeI>()

    useEffect(() => {

        const fetchHome = async () => {

            const homeDB = await getHome()
            const categoriasDB = await getHomeCategorias()


            setHome({
                ...homeDB,
                categorias: categoriasDB,
            })

        }

        fetchHome()

    }, [])

    return {
        home,
    }

}

export default useFetchHome